exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".c-legal h3,.primary{color:tomato}.c-legal h3+h3,.c-legal h3+section{margin-top:2em}.c-legal section{margin-bottom:2em}.c-legal .warning{color:red}.c-legal .black{color:#000}.c-legal .center{text-align:center}.c-legal ul.unstyled{list-style:none}.c-legal ol.alpha{list-style-type:lower-latin}.c-legal ul{margin-bottom:2em}.c-legal li{margin-bottom:1em}.c-legal p{margin-bottom:2em}", ""]);

// exports
